const t = {
  name: "Taiwan",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 19C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17C9.44772 17 9 17.4477 9 18C9 18.5523 9.44772 19 10 19Z" fill="currentColor"/>
<path d="M14 17C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15C13.4477 15 13 15.4477 13 16C13 16.5523 13.4477 17 14 17Z" fill="currentColor"/>
<path d="M12 14C12 14.5523 11.5523 15 11 15C10.4477 15 10 14.5523 10 14C10 13.4477 10.4477 13 11 13C11.5523 13 12 13.4477 12 14Z" fill="currentColor"/>
<path d="M17 8V2H15V8H3V10H5.15267L7.15267 22H16.8469L18.8469 10H21V8H17ZM16.8193 10L15.1527 20H14C14 19.4477 13.5523 19 13 19C12.4477 19 12 19.4477 12 20H8.84692L7.18026 10H16.8193Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Taiwan
};
